"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _column = _interopRequireDefault(require("./column"));
var _default = _column["default"];
exports["default"] = _default;